import _toConsumableArray from "/home/ubuntu/onesaz/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/home/ubuntu/onesaz/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _toArray from "/home/ubuntu/onesaz/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toArray";
import { unpack } from '../../utils/index.js';
import multiplyMatrices from '../../utils/multiply-matrices.js';
import { xyz2rgb } from '../lab/lab2rgb.js';
var oklab2rgb = function oklab2rgb() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  args = unpack(args, 'lab');
  var _args = args,
    _args2 = _toArray(_args),
    L = _args2[0],
    a = _args2[1],
    b = _args2[2],
    rest = _args2.slice(3);
  var _OKLab_to_XYZ = OKLab_to_XYZ([L, a, b]),
    _OKLab_to_XYZ2 = _slicedToArray(_OKLab_to_XYZ, 3),
    X = _OKLab_to_XYZ2[0],
    Y = _OKLab_to_XYZ2[1],
    Z = _OKLab_to_XYZ2[2];
  var _xyz2rgb = xyz2rgb(X, Y, Z),
    _xyz2rgb2 = _slicedToArray(_xyz2rgb, 3),
    r = _xyz2rgb2[0],
    g = _xyz2rgb2[1],
    b_ = _xyz2rgb2[2];
  return [r, g, b_].concat(_toConsumableArray(rest.length > 0 && rest[0] < 1 ? [rest[0]] : []));
};

// from https://www.w3.org/TR/css-color-4/#color-conversion-code
function OKLab_to_XYZ(OKLab) {
  // Given OKLab, convert to XYZ relative to D65
  var LMStoXYZ = [[1.2268798758459243, -0.5578149944602171, 0.2813910456659647], [-0.0405757452148008, 1.112286803280317, -0.0717110580655164], [-0.0763729366746601, -0.4214933324022432, 1.5869240198367816]];
  var OKLabtoLMS = [[1.0, 0.3963377773761749, 0.2158037573099136], [1.0, -0.1055613458156586, -0.0638541728258133], [1.0, -0.0894841775298119, -1.2914855480194092]];
  var LMSnl = multiplyMatrices(OKLabtoLMS, OKLab);
  return multiplyMatrices(LMStoXYZ, LMSnl.map(function (c) {
    return Math.pow(c, 3);
  }));
}
export default oklab2rgb;